export default __webpack_public_path__ + "static/media/logoufc.19bd0f83.svg";